import React from 'react';
import './Footer.css';
import { FaInstagram, FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Info Section */}
        <div className="footer-section">
          <div className="footer-logo">Skyline Backpackers</div>
          <p className="footer-description">
            Affordable and comfortable dormitory accommodations for travelers. 
            Experience the best of Hyderabad with our modern facilities and 
            friendly atmosphere.
          </p>
          <div className="footer-social-icons">
            <a href="https://www.instagram.com/skyline_backpackers/" target="_blank" rel="noopener noreferrer" className="footer-social-icon"><FaInstagram /></a>
          </div>
        </div>
        
        {/* Quick Links Section */}
        <div className="footer-section">
          <h3 className="footer-heading">Quick Links</h3>
          <ul className="footer-links">
            <li className="footer-link"><a href="#">Home</a></li>
            <li className="footer-link"><a href="#">About Us</a></li>
            <li className="footer-link"><a href="#">Rooms & Facilities</a></li>
            <li className="footer-link"><a href="#">Gallery</a></li>
            <li className="footer-link"><a href="#">Contact Us</a></li>
            <li className="footer-link"><a href="/terms-and-conditions">Terms & Conditions</a></li>
            <li className="footer-link"><a href="/privacy-policy">Privacy Policy</a></li>
            <li className="footer-link"><a href="/admin/login" className="footer-admin-login-btn">Admin Dashboard Login</a></li>
          </ul>
        </div>
        
        {/* Contact Info Section */}
        <div className="footer-section">
          <h3 className="footer-heading">Contact Info</h3>
          <div className="footer-contact-item">
            <FaMapMarkerAlt className="footer-contact-icon" />
            <a 
              href="https://maps.app.goo.gl/LfNQoinxVCTrdjQr8" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'none' }}
            >
              3rd Floor, ICICI Bank, 1-8, 303/30, Shree Arcade Building, PG Road, Sindhi Colony, Begumpet, Hyderabad, Telangana 500003
            </a>
          </div>
          <div className="footer-contact-item">
            <FaPhone className="footer-contact-icon" />
            <span>+91 90327 97797</span>
          </div>
          <div className="footer-contact-item">
            <FaEnvelope className="footer-contact-icon" />
            <span>booking@skylinebackpackers.in</span>
          </div>
          <div className="footer-contact-item">
            <FaClock className="footer-contact-icon" />
            <span>Check-in: 11:00 AM | Check-out: 10:00 AM</span>
          </div>
        </div>
        
        {/* Services Section */}
        <div className="footer-section">
          <h3 className="footer-heading">Our Services</h3>
          <ul className="footer-links">
            <li className="footer-link"><a href="#">Free WiFi</a></li>
            <li className="footer-link"><a href="#">Parking</a></li>
            <li className="footer-link"><a href="#">Centralised AC</a></li>
            <li className="footer-link"><a href="#">24/7 Support</a></li>
            <li className="footer-link"><a href="#">Clean Washrooms</a></li>
            <li className="footer-link"><a href="#">Lockers</a></li>
            <li className="footer-link"><a href="#">Cozy Beds</a></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-copyright">
        <p className="footer-copyright-text">&copy; {currentYear} Skyline Backpackers. All rights reserved.</p>
        <p className="footer-copyright-text">Designed with ❤️ for travelers</p>
      </div>
    </footer>
  );
};

export default Footer;
